import logger from '@tcp/core/src/utils/loggerInstance';
import { updateFilterFacet, getAPIConfig } from '@tcp/core/src/utils/';
import endpoints from '@tcp/core/src/services/endpoints.js';
import { executeUnbxdAPICall } from '@tcp/core/src/services/handler/index.js';
import { getFormattedError } from '@tcp/core/src/utils/errorMessage.util.js';
import {
  getStoreId,
  getStoreFilterData,
} from '@tcp/core/src/components/features/browse/ShopThisStore/container/ShopThisStore.utils';

// Remove the fields which are not needed
const fieldsVal =
  'TCPPromotions,tcp_promo_price,tcp_promotion_id,related_product_swatch_images,productimage,alt_img,style_partno,giftcard,swatchimage,TCPProductIndUSStore,TCPFitMessageUSSstore,TCPFit,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPSwatchesUSStore,top_rated,TCPSwatchesCanadaStore,product_name,TCPColor,imagename,productid,uniqueId,favoritedcount,TCPBazaarVoiceReviewCount,categoryPath3_fq,categoryPath3,categoryPath3_catMap,categoryPath2_catMap,product_short_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,seo_token,prodpartno,banner,facets,auxdescription,list_of_attributes,numberOfProducts,redirect,searchMetaData,didYouMean,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,TcpBossCategoryDisabled,TcpBossProductDisabled,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,product_type,products,low_offer_price, high_offer_price, low_list_price, high_list_price,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,TCPProductIndCanadaStore,TCPCustomSalePrice,TCPCustomListPrice,is_hard_mark_enable,influencer_tags,influencer_pick,store_specials,variantTotal,v_storeEligibleIds';

const fetchProducts = ({ xappURLConfig, facetsPayload, apiConfig, brand, store }) => {
  const { isBotRequest } = getAPIConfig();

  // Determine the promotion rule based on the bot category IDs and the bot request status
  const promotionRule = { promotion: false };
  const eligibleStoreFilter = { filter: `v_storeEligibleIds:${getStoreId(store)}` };
  const payload = {
    body: {
      start: 0,
      rows: 12,
      variants: true,
      'variants.count': 0,
      version: 'V2',
      stats: 'min_offer_price',
      'facet.multiselect': true,
      selectedfacet: true,
      pagetype: 'boolean',
      fields: fieldsVal,
      ...(isBotRequest ? promotionRule : {}),
      ...(updateFilterFacet(facetsPayload) || {}),
      brand,
      q: '*',
      filter: `${encodeURIComponent(getStoreFilterData(store))}&filter=${
        eligibleStoreFilter.filter
      }`,
    },
    webService: endpoints.getProductsBySearchTerm,
  };

  return executeUnbxdAPICall(payload, null, xappURLConfig, apiConfig)
    .then((res) => {
      return res?.body;
    })
    .catch((err) => {
      logger.error({
        error: `Error while executing Unbxd API call for Store Special Caraosal catch - ${err}`,
        extraData: {
          componentName: 'StoreDetailPage',
          methodName: 'fetchProducts',
        },
      });
      throw Object.assign(getFormattedError(err), { isServiceError: true });
    });
};

export default fetchProducts;
